import { AnimatePresence, type AnimatePresenceProps } from "motion/react";
import React, { ReactElement } from "react";

export default function AnimatePresenceWrapper({
  children,
  ...props
}: AnimatePresenceProps & { children: ReactElement | ReactElement[] | null }) {
  return <AnimatePresence {...props}>{children}</AnimatePresence>;
}
